/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-07 09:55:12
 */
import { useEffect, useState } from "react";
import Header from "../../components/header/index";
import Menu from "./menu/index";
import Breadcrumb from "./breadcrumb/index";
import { Outlet, useLocation } from "react-router-dom";
import "./_style.scss";
import { BreadcrumbItem } from "@root/common/interface/result";
import { useSelector } from "react-redux";
import { RootState, store } from "@root/store";
import { setMenuColumnId } from "@root/reducers/menuColumnId";

// 用于通过 菜单栏目id, 获取路由
const locationHashByColumnIdMap = new Map<number, string>();

export default function Index() {
  const { pathname } = useLocation();
  const curMenuColumnId = useSelector(
    (state: RootState) => state.menuColumnId.columnId
  );
  // 设置menu selected item （menu item的key统一配置为当前menu item的pathname，方便setDefaultKeys）
  const [defaultKeys, setDefaultKeys] = useState(pathname || "index");

  const [allBreadcrumbs, setAllBreadcrumbs] = useState<any>();
  const [curBreadcrumb, setCurBreadcrumb] = useState<BreadcrumbItem>();

  useEffect(() => {
    // 初始化(栏目id: 菜单path)数据源
    if (!allBreadcrumbs) {
      return;
    }
    Object.keys(allBreadcrumbs).forEach((pathKey) => {
      locationHashByColumnIdMap.set(allBreadcrumbs[pathKey].columnId, pathKey);
    });
  }, [allBreadcrumbs]);

  useEffect(() => {
    if (!allBreadcrumbs || !allBreadcrumbs[pathname]) {
      return;
    }
    store.dispatch(
      setMenuColumnId({ columnId: allBreadcrumbs[pathname].columnId })
    );
  }, [pathname, allBreadcrumbs]);
  useEffect(() => {
    if (!allBreadcrumbs) {
      return;
    }

    let curPathname: string | undefined =
      locationHashByColumnIdMap.get(curMenuColumnId);
    if (!curPathname) {
      return;
    }

    // 根据路由，设置当前菜单(被选中)
    setDefaultKeys(curPathname);
    // 根据路由，设置当前面包屑(内容)
    setCurBreadcrumb(allBreadcrumbs[curPathname]);
  }, [curMenuColumnId, allBreadcrumbs]);

  return (
    <div>
      <div className="header-box">
        <Header />
        <Menu
          defaultKeys={defaultKeys}
          setDefaultKeys={setDefaultKeys}
          setInitBreadcrumbs={setAllBreadcrumbs}
        />
      </div>
      <Breadcrumb
        curBreadcrumb={curBreadcrumb}
        pathname={pathname}
        setDefaultKeys={setDefaultKeys}
      />
      <Outlet />
    </div>
  );
}
